var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreathingExercises(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48 25.1667L48 31.4167",
    stroke: "#6054B8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 60.5834L48 66.8334",
    stroke: "#6054B8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8333 46L62.5833 46",
    stroke: "#6054B8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4166 46L27.1666 46",
    stroke: "#6054B8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7313 31.2686L58.3119 35.688",
    stroke: "#6054B8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.688 56.3125L33.2686 60.7319",
    stroke: "#6054B8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2686 31.2686L37.688 35.688",
    stroke: "#6054B8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3119 56.3125L62.7313 60.7319",
    stroke: "#6054B8",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5,
    width: 82,
    height: 82,
    rx: 41,
    stroke: "url(#paint0_linear_2444_86045)",
    strokeWidth: 6,
    shapeRendering: "geometricPrecision"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2444_86045",
    x1: 4,
    y1: 46,
    x2: 92,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A69AFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6054B8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreathingExercises);
export default __webpack_public_path__ + "static/media/breathing-exercises.f00cc26c1f773f9c7e3eb1a3f71c75af.svg";
export { ForwardRef as ReactComponent };